import { useState } from "react";
import { FAQS } from "@/mocks/contents";

export default function FaqBlock() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-12 md:py-16" aria-label="常见问题">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <span className="text-xs font-bold tracking-[0.2em] text-primary-600">FAQ · 常见问题</span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              关于吃瓜，你想问的都在这
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              内容怎么生产、信息怎么核验、隐私边界怎么把握、出了错怎么处理——这些约定，我们希望能说得明明白白。
            </p>
            <div className="mt-6 rounded-2xl border border-background-200 bg-background-50 p-6">
              <div className="flex items-center gap-2">
                <i className="ri-mail-send-line text-xl text-primary-600" aria-hidden="true"></i>
                <h3 className="font-heading text-base font-bold text-foreground-950">还有疑问或指正？</h3>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                遇到内容错误、投诉或建议，欢迎发邮件，值班编辑会在 2 个工作日内核验回复。
              </p>
              <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-background-100 px-4 py-2 text-sm font-semibold text-primary-800">
                <i className="ri-mail-line" aria-hidden="true"></i>
                hello@chiguaheilia.com
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="flex flex-col gap-3">
              {FAQS.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={f.q}
                    className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                      isOpen ? "border-primary-300" : "border-background-200"
                    }`}
                  >
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full font-heading text-xs font-bold ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className="text-sm font-bold text-foreground-950 md:text-base">{f.q}</span>
                      </span>
                      <i
                        className={`text-xl text-foreground-500 transition-transform ${isOpen ? "rotate-180 text-primary-600" : ""} ${
                          isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="border-t border-background-100 px-5 pb-5 pt-4 md:px-6">
                        <p className="pl-9 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}